import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'features/store';

export type MenuState = {
    opened: boolean;
    validationCount: number;
};

const initialMenuState = {
    opened: false,
    validationCount: 0
};

export const menuSlice = createSlice({
    name: 'menu',
    initialState: initialMenuState,
    reducers: {
        setSidebarState: (state, data) => {
            const { opened } = data.payload;
            state.opened = opened;
        },
        toggleSidebar: (state) => {
            state.opened = !state.opened;
        },
        setValidationCount: (state, data) => {
            const { count } = data.payload;
            state.validationCount = count;
        }
    }
});
export const getSidebarState = (state: RootState) => state.menu.opened;
export const getValidationCount = (state: RootState) => state.menu.validationCount;
export const { setSidebarState, toggleSidebar, setValidationCount } = menuSlice.actions;

export default menuSlice.reducer;
